// import qs from 'query-string';
import { post } from './baseApi';

export const AuthApi = {
    login: (data) => post('/auth/login', data),
    // fetchUsers: (data) => get(`/users?${qs.stringify(data)}`),
};
